import { useCallback, useState } from "react";
import { syncTangoMerchantBrands } from "../api/merchantBrands.api";
import type { SyncMerchantBrandsResponse } from "../types/merchantBrand.types";

export function useSyncMerchantBrands() {
  const [loading, setLoading] = useState(false);

  const sync = useCallback(async (): Promise<SyncMerchantBrandsResponse> => {
    setLoading(true);
    try {
      return await syncTangoMerchantBrands();
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, sync };
}
